import UserState from "./user-state.ts";
import GroupState from "./group-state.ts";

export default class State {
  public userState: UserState;
  public groupState: GroupState;
  public categories: string[] | null;

  constructor() {
    this.userState = new UserState();
    this.groupState = new GroupState();
    this.categories = null;
  }
}
